import Vue from 'vue';
import { ScopedSlotChildren } from 'vue/types/vnode';

export function hasSlot(this: Vue, name = 'default'): boolean {
  return (
    this.$slots[name] !== undefined || this.$scopedSlots[name] !== undefined
  );
}

export function normalizeSlot(
  this: Vue,
  name = 'default',
  scope = {}
): ScopedSlotChildren {
  const slot = this.$scopedSlots[name] || this.$slots[name];
  return typeof slot === 'function' ? slot(scope) : slot;
}
